import React from 'react';

export default function CountryFlagIcon() {
  return (
    <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3382_2919)">
        <rect x="0.25" width="24.75" height="18" rx="2" fill="white" />
        <path d="M22.6429 0H2.60714C1.30533 0 0.25 1.07452 0.25 2.4V15.6C0.25 16.9255 1.30533 18 2.60714 18H22.6429C23.9447 18 25 16.9255 25 15.6V2.4C25 1.07452 23.9447 0 22.6429 0Z" fill="white" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 12H25V18H0.25V12Z" fill="#1A47B8" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 0H25V6H0.25V0Z" fill="#F93939" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.69389 12L2.60714 18.0396H0.25V0H2.60714L9.67857 6H25V12H9.69389Z" fill="white" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.325 10.8L0.839286 18L0.25 18.0396V0H0.839286L9.325 7.2H25V10.8H9.325Z" fill="#249F58" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 3.6001L7.32143 9.0001L0.25 14.4001V3.6001Z" fill="#FFDA2C" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 4.80005L5.84821 9.00005L0.25 13.2V4.80005Z" fill="#151515" />
      </g>
      <defs>
        <clipPath id="clip0_3382_2919">
          <rect x="0.25" width="24.75" height="18" rx="2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
